export default (params = {}) => new Promise((resolve) => {
  const { requestIdleCallback, setTimeout } = window;
  const { duration: milliseconds = 500 } = params;

  setTimeout(
    () => (requestIdleCallback ? requestIdleCallback(resolve) : resolve()),
    milliseconds,
  );
});
